import React from "react";
import { Helmet } from "react-helmet-async";
import {
  Typography,
  Breadcrumbs as MuiBreadcrumbs,
  Link,
  Divider as MuiDivider,
  Paper,
  Container,
} from "@material-ui/core";
import { NavLink } from "react-router-dom";
import { spacing } from "@material-ui/system";
import { Alert } from "@material-ui/lab";
import styled from "styled-components/macro";
import { RebuildMapLayerButton } from "./RebuildMapLayerButton";
import { PublishWaterLevelsButton } from "./PublishWaterLevelsButton";

const Divider = styled(MuiDivider)(spacing);
const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

const SectionPaper = styled(Paper)`
  padding: 16px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export default function PublishData() {
  return (
    <>
      <Helmet title="Publish Data" />

      <Typography variant="h3" gutterBottom display="inline">
        Publish Data
      </Typography>

      <Breadcrumbs aria-label="Breadcrumb" mt={2}>
        <Link component={NavLink} exact to="/dashboard">
          Dashboard
        </Link>
        <Typography>Publish Data</Typography>
      </Breadcrumbs>

      <Divider my={6} />

      <Container maxWidth="md">
        <SectionPaper elevation={0} style={{ marginBottom: "16px" }}>
          <Typography variant="h6" style={{ marginBottom: "16px" }}>
            Force Refresh of Wells Map Layer
          </Typography>
          <Alert severity="info" style={{ marginBottom: "16px" }}>
            <Typography variant="body1" paragraph>
              To improve performance for editing and data entry, most edits to
              wells, permits, and associated information will not force a
              re-build of the wells map layer. The map is refreshed nightly at 3
              AM and also after the specific actions listed below. Use the
              button below to force a refresh when other changes have been made
              and you want them to be reflected on the map immediately.
            </Typography>
            <ul style={{ textAlign: "left" }}>
              <li>
                A new well is created (but not for subsequent edits of that new
                well's information, except for the changes included below)
              </li>
              <li>A well's published status is changed</li>
              <li>A well's removed status is changed</li>
              <li>A well's lat/lon coordinates are changed</li>
            </ul>
          </Alert>
          <RebuildMapLayerButton />
        </SectionPaper>

        <SectionPaper elevation={0}>
          <Typography variant="h6" style={{ marginBottom: "16px" }}>
            Publish Water Levels to Graphs
          </Typography>
          <Alert severity="info" style={{ marginBottom: "16px" }}>
            <Typography variant="body1">
              <strong>NOTE:</strong> Water Levels entered into the system are
              not published to the graphs accessible on the main map
              immediately. Each night a function runs that publishes new data.
              Use the button below to force new water level records to publish
              right away. This process takes approximately{" "}
              <strong>30 seconds</strong> to complete and updates should be live
              in <strong>no more than 1 minute</strong>. If you do not see the
              changes within one minute, please refresh your page. If the
              updates still do not appear after refreshing, then contact LRE
              Water.
            </Typography>
          </Alert>
          <PublishWaterLevelsButton />
        </SectionPaper>
      </Container>
    </>
  );
}
